import React from "react";

function Underline({
  text,
  color = "var(--pallete-main)",
  nowrapRemoved = false,
}) {
  return (
    <span
      style={{
        textDecoration: "underline",
        textDecorationColor: color,
        textDecorationSkipInk: "none",
        textDecorationThickness: "15px",
        textUnderlineOffset: "-9px",
        whiteSpace: nowrapRemoved ? "unset" : "nowrap",
      }}
    >
      {text}
    </span>
  );
}

export default Underline;
